const urlsToExecuteUpdate = require("./Constants");

const appendSlashToUrls = (urls) => urls?.map(url => [url, `${url}/`]).flat();

const shouldReloadOnRouteUpdate = (location, prevLocation) => (
    location &&
    prevLocation &&
    location?.pathname !== prevLocation?.pathname &&
    appendSlashToUrls(urlsToExecuteUpdate).includes(location.pathname)
);


const onRouteUpdate = async ({ location, prevLocation }) => {
    if (window && shouldReloadOnRouteUpdate(location, prevLocation)) {
        window.location.reload();
        return;
    }

    // Scroll to top on route change (without hash anchors)
    // setTimeout is necessary because Gatsby's routing is async and content is still rendering
    if (!location.hash && typeof window !== 'undefined') {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }
};

module.exports = { onRouteUpdate, appendSlashToUrls }